import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import classNames from 'classnames'
import Button from '~components/ui/Button'

const PaymentForm = ({ onError = () => {}, onSuccess = () => {}, returnUrl, classes }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!stripe || !returnUrl) return

    const clientSecret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    )

    if (!clientSecret) return

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          onSuccess('Payment succeeded!')
          break
        case 'processing':
          onSuccess('Your payment is processing.')
          break
        case 'requires_payment_method':
          onError('Your payment was not successful, please try again.')
          break
        default:
          onError('Something went wrong.')
          break
      }
    })
  }, [stripe])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!stripe || !elements) return

    setIsLoading(true)

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl
      }
    })

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === 'card_error' || error.type === 'validation_error') {
      onError(error.message)
    } else {
      onError(error.message)
    }

    setIsLoading(false)
  }

  return (
    <form
      id="payment-form"
      onSubmit={handleSubmit}
      className={classNames('w-full', classes)}
    >
      <PaymentElement id="payment-element" />

      <Button
        disabled={isLoading || !stripe || !elements}
        busy={isLoading || !stripe || !elements}
        type="submit"
        className="mt-10"
      >
        Pay now
      </Button>
    </form>
  )
}

PaymentForm.propTypes = {
  classes: PropTypes.string,
  returnUrl: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

export default PaymentForm
